<div
  class="single-select-filter-container"
  [ngClass]="[disabled ? 'single-select-filter--disable' : '']"
>
  <label class="single-select-filter-label">{{ label }}</label>
  <nz-select
    [(ngModel)]="selectedItem"
    [ngStyle]="{ width: width }"
    (ngModelChange)="onItemChange($event)"
    nzDropdownClassName="single-select-overlay"
    [nzPlaceHolder]="placeholder"
    [nzDisabled]="disabled"
    class="single-select-filter"
    nzBorderless
  >
    <ng-container *ngFor="let item of items">
      <nz-option
        *ngIf="!treatValueAsLable"
        [nzValue]="item.value"
        [nzLabel]="item.key"
        [nzDisabled]="item.disabled || false"
      ></nz-option>
      <nz-option
        *ngIf="treatValueAsLable"
        [nzValue]="item"
        [nzLabel]="item"
      ></nz-option>
    </ng-container>
  </nz-select>
</div>
